import 'whatwg-fetch';
const env = process.env;

const getLoggedUser = () => {
	var userJson = window.localStorage.getItem('user');
	if (userJson && userJson != '') {
		return JSON.parse(userJson);
	}
	return {}
}

const logout = (apitoken) => {
	window.localStorage.clear();

	return fetch(`${env.VUE_APP_trimaster}/api/v1/users/logout?access_token=${apitoken.apitoken}`, {
		method: 'POST',
		headers: {
			Accept: 'application/json'
		}
	});
}



const setupAccount = (payload) => {
	console.log("payload: ", payload)
	return fetch(`${env.VUE_APP_trimaster}/api/v1/checkInvitation/checkinvite`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({
			"password": payload.password,
			"confirmPassword": payload.confirmPassword,
			"code": payload.code
		})
	});
}

const getMenuForCurrentUser = (payload) => {
	return fetch(`${env.VUE_APP_trimaster}/api/v1/ag_navigationMenus/getMenuForCurrentUser?access_token=${payload.apitoken}&facility_id=${payload.facility_id}`, {
		method: 'GET',
		headers: {
			Accept: 'application/json'
		},
	});
}

export default {
	getLoggedUser,
	logout,
	setupAccount,
	getMenuForCurrentUser,
}
